<template>
    <ModalComponent
        :name="'editar-' + puerta.id"
        title="Editar puerta"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="editarPuerta()">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Nombre" name="nombre" rules="required" v-model="puerta.nombre" />
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <Button type="submit" name="button" id="submit-sale-ad">Continuar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['puerta', 'evento_id'],
        data() {
            return {
            }
        },
        methods: {
            close(editado) {
                this.$emit('close', 'editar-' + this.puerta.id, editado);
            },
            editarPuerta() {
                this.puerta.filters = {};
                this.puerta.puerta_id = this.puerta.id;
                this.puerta.evento_id = this.evento_id;

                this.$store.dispatch(this.config.getVuexAlias('back.events.puertas.editar'), this.puerta).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                    this.loading = false;
                });
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
